import * as React from 'react';

import type { InformationCardToggleProps } from 'bundles/enterprise-legacy-learner-home/components/InformationCard/InformationCardToggle';
import InformationCardToggle from 'bundles/enterprise-legacy-learner-home/components/InformationCard/InformationCardToggle';

import _t from 'i18n!nls/enterprise-legacy-learner-home';

type Props = Omit<InformationCardToggleProps, 'label' | 'trackingName'>;

const HowItWorksInformationLink: React.FC<Props> = (props) => (
  <InformationCardToggle {...props} label={_t('How it works')} trackingName="how_it_works_information_link" />
);

export default HowItWorksInformationLink;
